/**
 * 供应商
 * */
//供应商视图页
import view from '@/page/supplier/view/view';
//供应商资料变更审核
import approvalSupList from '@/page/supplier/approval/approval-sup-list';
import newSupList from '@/page/supplier/approval/new-sup-list';
//供应商品类管理
import supType from '@/page/supplier/sup-type/sup-type';
//供应商商品管理
import supGoodsList from '@/page/supplier/goods/sup-goods-list';
//采购  供应商绩效
import assessReport from '@/page/supplier-assess/assess-report';
import mineAssess from '@/page/supplier-assess/mine-assess';
//供应商账号
import supplierAccountQuery from '@/page/supplier-account/supplier-account-query';
import accountDetail from '@/page/supplier-account/account-detail';
//供应商资质过期
import qualificationExpiresQuery from '@/page/supplier-qualification-expires/qualification-expires-query';
/**
 * 物料管理
 */
//配额管理
import materialQuotaManage from '@/page/material-quota-manage/material-quota-manage';
//货源管理
import materialSourceAllocation from '@/page/material-source-allocation/material-source-allocation';
//虚拟物料管理
import virtualMaterialManagement from '@/page/virtual-material-management/virtual-material-management';
import virtualMaterialManagementview from '@/page/virtual-material-management/virtual-material-management-view';
//物料信息库
import materialInfoList from '@/page/material-info-library/material-info-list';
import materialDocReleaseList from '@/page/material-doc-release/material-doc-release-list';
import materialInfoView from '@/page/material-info-library/material-info-view';
import MatUnit from '@/page/material-info-library/mat-unit';
import MatPlant from '@/page/material-info-library/mat-plant';
export default [
  /**
   * 供应商信息
   */
  //供应商视图
  {
    path: '/sup-view/:id',
    component: view,
    meta: {
      title: '供应商资料'
    }
  },
  //供应商资料变更
  {
    path: '/sup/approval/:listType',
    component: approvalSupList,
    meta: {
      title: '资料变更待办'
    }
  },
  //新供应商资料审批
  {
    path:'/new-sup/approval',
    component:newSupList,
    meta:{
      title:'新供应商资料审批'
    }
  },
  // 供应商绩效
  {
    path: '/assess-report',
    component: assessReport,
    meta: {title: '供应商绩效'}
  },
  {
    path: '/mine-assess-report',
    component: mineAssess,
    meta: {title: '我的考核'}
  },
  //供应商账号
  {
    path: '/supplier-account',
    component: supplierAccountQuery,
    meta: {title: '供应商账号管理'}
  },
  {
    path: '/supplier-account-detail/:name',
    component: accountDetail,
    meta: {title: '供应商账号详情'}
  },
  {
    path:'/supplier-account-detail',
    component: accountDetail,
    meta: {title: '我的账号'}
  },
  //供应商资质过期查询
  {
    path: '/supplier-expires',
    component: qualificationExpiresQuery,
    meta: {title: '供应商资质过期查询'}
  },
  {
    path: '/sup-type',
    component: supType,
    meta: {
      title: '供应商品类管理'
    }
  },
  {
    path: '/sup-goods-list/:listType',
    component: supGoodsList,
    meta: {
      title: '供应商商品管理'
    }
  },
  {
    path: '/material-quota-manage',
    component: materialQuotaManage,
    meta: {
      title: '配额管理'
    }
  },
  {
    path: '/material-source-allocation',
    component: materialSourceAllocation,
    meta: {
      title: '货源管理'
    }
  },
  {
    path: '/virtual-material-management',
    component: virtualMaterialManagement,
    meta: {
      title: '虚拟物料管理'
    }
  },
  {
    path: '/virtual-material-management-view/:id',
    name: 'virtual-material-management-view',
    component: virtualMaterialManagementview,
    meta: {
      title: '虚拟物料管理详情'
    }
  },
  {
    path: '/material-info-list',
    name: 'material-info-list',
    component: materialInfoList,
    meta: {
      title: '物料信息列表'
    }
  },
  {
    path: '/material-info-view/:id',
    name: 'material-info-view',
    component: materialInfoView,
    meta: {
      title: '物料信息详情'
    }
  },
  {
    path: '/material-doc-release',
    name: 'material-doc-release',
    component: materialDocReleaseList,
    meta: {
      title: '物料文档发布'
    }
  },
  {
    path: '/mat-unit',
    name: 'mat-unit',
    component: MatUnit,
    meta: {
      title: '物料单位转换'
    }
  },
  {
    path:'/mat-plant',
    name:'mat-plant',
    component:MatPlant,
    meta:{
      title: '物料工厂'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/supplier.js